import React, { useState, useEffect, lazy, Suspense } from "react";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { BrowserRouter as Router } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { connect } from "react-redux";
import { authActions } from "./reducers/authReducer";
import { locationActions } from "./reducers/locationReducer";

import axios from "axios";

import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import LinearProgress from "@mui/material/LinearProgress";


// ======================================================
// Lazy Loading
// ======================================================

const Layout = lazy(function () {
    return import("./components/Layout");
});

const LayoutLdf = lazy(function () {
    return import("./components/LayoutLdf");
});

const LandingPage = lazy(function () {
    return import("./components/Login/LandingPage");
});


// ======================================================
// RTL Cache
// ======================================================

const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [rtlPlugin],
});


// ======================================================
// MUI Theme
// ======================================================

const theme = createTheme({
    direction: "rtl",

    palette: {
        primary: {
            main: "#5d78ff",
        },

        secondary: {
            main: "#0abb87",
            contrastText: "#ffffff",
        },

        error: {
            main: "#fd397a",
        },
    },

    components: {
        MuiDialogTitle: {
            defaultProps: {
                gutterBottom: true,
            },

            styleOverrides: {
                root: {
                    backgroundColor: "#999",
                    color: "#eee",
                    textAlign: "center",
                },
            },
        },

        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                size: "small",

                InputLabelProps: {
                    shrink: true,
                },

                variant: "outlined",
            },
        },
    },
});


// ======================================================
// App
// ======================================================

function App(props) {

    const [loading, setLoading] = useState(false);

    const [LoginState, setLoginState] = useState({
        state: false,
        type: "",
    });

    const [backurl, setbackurl] = useState("");


    // ==================================================
    // Get first directory
    // ==================================================

    const getFirstDirectory = () => {
        return window.location.pathname.split("/")[1];
    };


    // ==================================================
    // Generate Token
    // ==================================================

    function generateToken(user) {
    }


    // ==================================================
    // Initial setup
    // ==================================================

    React.useLayoutEffect(() => {

        // serviceWorker.register();

        document.body.setAttribute("dir", "rtl");

    }, []);


    // ==================================================
    // Check Login
    // ==================================================

    useEffect(() => {

        setLoginState({
            state: false,
            type: "Generall",
        });


        // ----------------------------------------------
        // Backend URL
        // ----------------------------------------------

        if (window.location.host.includes("localhost")) {

            setbackurl("https://localhost:44336");

        } else {

            setbackurl("http://panjerehman.ir//api");

        }


        // ----------------------------------------------
        // Reset form data
        // ----------------------------------------------

        localStorage.setItem(
            "formDataArray",
            JSON.stringify([])
        );


        // ----------------------------------------------
        // Special paths
        // ----------------------------------------------


        const isSpecialPathLnaf = window.location.pathname.includes("/Lnaf")
        const isSpecialPathLLmaf = window.location.pathname.includes("/Lmaf")
        const isSpecialPathLfaf = window.location.pathname.includes("/Lfaf");
        const urlSearchString = window.location.search;
        const params = new URLSearchParams(urlSearchString);
        const Currenttoken = params.get("Token");

       

        if (isSpecialPathLnaf) {
            return;
        }

        // ----------------------------------------------
        // Check authentication
        // ----------------------------------------------

        try {

            let login = JSON.parse(
                localStorage.getItem("auth")
            );

            let LoginMobileAuth = JSON.parse(
                localStorage.getItem("LoginMobileAuth")
            );


            // ------------------------------------------
            // Tomorrow date
            // ------------------------------------------

            var date = new Date();

            date.setDate(
                date.getDate() + 1
            );

            var day = String(
                date.getDate()
            ).padStart(2, "0");

            var month = String(
                date.getMonth() + 1
            ).padStart(2, "0");

            var year = date.getFullYear();

            var nowdate =
                day +
                "/" +
                month +
                "/" +
                year;
debugger;

            // ------------------------------------------
            // Normal login
            // ------------------------------------------
            if (!isSpecialPathLLmaf && !isSpecialPathLnaf && !isSpecialPathLfaf && login && nowdate === login.expireDate
            ) {

                props.userLogin(login);

                setLoginState({
                    state: true,
                    type: "Generall",
                });

            }
            else if (
                isSpecialPathLfaf && login.user.formTokenAccess.currentToken === Currenttoken
                && login &&
                nowdate === login.expireDate
            ) {

                props.userLogin(login);

                setLoginState({
                    state: true,
                    type: "Ldf",
                });

            }
            // ------------------------------------------
            // Mobile login
            // ------------------------------------------

            else if (
                isSpecialPathLLmaf && LoginMobileAuth.user.formTokenAccess.currentToken === Currenttoken
                && LoginMobileAuth &&
                nowdate === LoginMobileAuth.expireDate
            ) {

                props.userLogin(LoginMobileAuth);

                setLoginState({
                    state: true,
                    type: "Ldf",
                });

            }

            // ------------------------------------------
            // Not logged in
            // ------------------------------------------

            else {

                props.userLogin({
                    loggedIn: false,
                    user: "",
                    authToken: "",
                    backurl: "",
                    expireDate: "",
                });


                localStorage.setItem(
                    "auth",
                    JSON.stringify({
                        loggedIn: false,
                        user: "",
                        authToken: "",
                        backurl: "",
                        expireDate: "",
                    })
                );


                setLoginState({
                    state: false,
                    type: "Generall",
                });


                localStorage.setItem(
                    "formDataArray",
                    JSON.stringify([])
                );
            }

        } catch {

            props.userLogin({
                loggedIn: false,
                user: "",
                authToken: "",
                backurl: "",
                expireDate: "",
            });


            localStorage.setItem(
                "auth",
                JSON.stringify({
                    loggedIn: false,
                    user: "",
                    authToken: "",
                    backurl: "",
                    expireDate: "",
                })
            );


            setLoginState({
                state: false,
                type: "Generall",
            });


            localStorage.setItem(
                "formDataArray",
                JSON.stringify([])
            );
        }

    }, []);


    // ==================================================
    // Get Site Info
    // ==================================================

    const Getsiteinfo = async (
        siteid,
        token,
        sitename
    ) => {

        var login = {
            sitename: sitename,
            token: token,
            site: siteid,
        };


        try {

            if (
                siteid !== null ||
                token !== null ||
                sitename !== null
            ) {

                var response = null;


                response = await axios.request({
                    method: "Post",
                    url:
                        backurl +
                        "/api/Auth/GetSiteinfo",
                    responseType: "json",
                    data: login,
                }).catch(error => {
                });


                if (response.data.succeed) {

                    localStorage.setItem(
                        response.data.data.site_EnName,
                        JSON.stringify(
                            response.data.data
                        )
                    );


                    return response.data.data;

                } else {

                    localStorage.setItem(
                        response.data.data.site_EnName,
                        JSON.stringify(null)
                    );


                    return "basesite";
                }

            } else {

                localStorage.setItem(
                    response.data.data.site_EnName,
                    JSON.stringify(null)
                );


                return "basesite";
            }

        } catch (err) {
        }

    };


    // ==================================================
    // New User Registration
    // ==================================================

    const NewUserRegistration = async (
        FormVaribale
    ) => {

        try {

            var response = null;


            response = await axios.request({
                method: "POST",
                url:
                    backurl +
                    "/api/Auth/RegistrationUser",
                responseType: "json",
                data: FormVaribale,
            }).catch(error => {
            });


            return response;

        } catch (err) {
        }

    };


    // ==================================================
    // Get Validation Code
    // ==================================================

    const GetValidationCode = async (
        FormVaribale
    ) => {

        try {

            var response = null;


            response = await axios.request({
                method: "POST",
                url:
                    backurl +
                    "/api/Auth/GetValidationCode",
                responseType: "json",
                data: FormVaribale,
            }).catch(error => {
            });


            return response;

        } catch (err) {
        }

    };


    // ==================================================
    // Get Validation Code Forget
    // ==================================================

    const GetValidationCodeForget = async (
        FormVaribale
    ) => {

        try {

            var response = null;


            response = await axios.request({
                method: "POST",
                url:
                    backurl +
                    "/api/Auth/GetValidationCodeForget",
                responseType: "json",
                data: FormVaribale,
            }).catch(error => {
            });


            return response;

        } catch (err) {
        }

    };


    // ==================================================
    // Forget Password
    // ==================================================

    const ForgerPassword = async (
        FormVaribale
    ) => {

        try {

            var response = null;


            response = await axios.request({
                method: "POST",
                url:
                    backurl +
                    "/api/Auth/ForgerPassword",
                responseType: "json",
                data: FormVaribale,
            }).catch(error => {
            });


            return response;

        } catch (err) {
        }

    };


    // ==================================================
    // Login
    // ==================================================

    const login = async (userid, userpass, site, token, sitename
    ) => {

        localStorage.setItem(
            "HomeMenuState",
            ""
        );


        var login = {
            userid: userid,
            userpass: userpass,
            token: token,
            site: site,
            sitename: sitename,
        };


        var response = null;


        response = await axios.request({
            method: "POST",
            url:
                backurl +
                "/api/Auth/Login",
            responseType: "json",
            data: login,
        }).catch(error => {
        });


        try {

            if (response.data.succeed) {

                setLoginState({
                    state: true,
                    type: "Generall",
                });


                if (
                    response.data.data.user.formTokenAccess !== null &&
                    response.data.data.user.formTokenAccess.authType === 3
                ) {

                    setLoginState({
                        state: true,
                        type: "Ldf",
                    });

                }


                props.userLogin({
                    loggedIn: response.data.succeed,
                    user: response.data.data.user,
                    authToken: response.data.data.authToken,
                    backurl: backurl,
                    expireDate: response.data.data.expireDate,
                });


                localStorage.setItem(
                    "auth",
                    JSON.stringify({
                        loggedIn: response.data.succeed,
                        user: response.data.data.user,
                        authToken: response.data.data.authToken,
                        backurl: backurl,
                        expireDate: response.data.data.expireDate,
                    })
                );


                return {
                    succeed: true,
                    msg: "ورود با موفقیت انجام شد",
                };

            } else {

                props.userLogin({
                    loggedIn: false,
                    user: "",
                    authToken: "",
                    backurl: "",
                    expireDate: "",
                });


                localStorage.setItem(
                    "auth",
                    JSON.stringify({
                        loggedIn: false,
                        user: "",
                        authToken: "",
                        backurl: "",
                        expireDate: "",
                    })
                );


                return {
                    succeed: false,
                    msg: response.data.errorMessage,
                };
            }

        } catch {

            return {
                succeed: false,
                msg: "امکان ارتباط وجود ندارد",
            };

        }

    };


    // ==================================================
    // Login No Auth
    // ==================================================

    const LoginNoAuth = async (
        Token
    ) => {

        var response = null;


        var login = {
            Token: Token,
        };


        response = await axios.request({
            method: "POST",
            url:
                backurl +
                "/api/Auth/LoginNoAuth",
            responseType: "json",
            data: login,
        }).catch(error => {
        });


        try {

            if (response.data.succeed) {

                setLoginState({
                    state: true,
                    type: "Ldf",
                });


                props.userLogin({
                    loggedIn: response.data.succeed,
                    user: response.data.data.user,
                    authToken: response.data.data.authToken,
                    backurl: backurl,
                    expireDate: response.data.data.expireDate,
                });


                localStorage.setItem(
                    "LoginNoAuth",
                    JSON.stringify({
                        loggedIn: response.data.succeed,
                        user: response.data.data.user,
                        authToken: response.data.data.authToken,
                        backurl: backurl,
                        expireDate: response.data.data.expireDate,
                    })
                );


                return {
                    succeed: true,
                    msg: "ورود با موفقیت انجام شد",
                };

            } else {

                props.userLogin({
                    loggedIn: false,
                    user: "",
                    authToken: "",
                    backurl: "",
                    expireDate: "",
                });


                localStorage.setItem(
                    "LoginNoAuth",
                    JSON.stringify({
                        loggedIn: false,
                        user: "",
                        authToken: "",
                        backurl: "",
                        expireDate: "",
                    })
                );


                return {
                    succeed: false,
                    msg: response.data.errorMessage,
                };
            }

        } catch {

            return {
                succeed: false,
                msg: "امکان ارتباط وجود ندارد",
            };

        }

    };


    // ==================================================
    // Login Mobile Auth
    // ==================================================

    const LoginMobileAuth = async (
        login
    ) => {

        var response = null;


        response = await axios.request({
            method: "POST",
            url:
                backurl +
                "/api/Auth/LoginMobileAuth",
            responseType: "json",
            data: login,
        }).catch(error => {
        });


        try {

            if (response.data.succeed) {

                setLoginState({
                    state: true,
                    type: "Ldf",
                });


                props.userLogin({
                    loggedIn: response.data.succeed,
                    user: response.data.data.user,
                    authToken: response.data.data.authToken,
                    backurl: backurl,
                    expireDate: response.data.data.expireDate,
                });


                localStorage.setItem(
                    "LoginMobileAuth",
                    JSON.stringify({
                        loggedIn: response.data.succeed,
                        user: response.data.data.user,
                        authToken: response.data.data.authToken,
                        backurl: backurl,
                        expireDate: response.data.data.expireDate,
                    })
                );


                return {
                    succeed: true,
                    msg: "ورود با موفقیت انجام شد",
                };

            } else {

                props.userLogin({
                    loggedIn: false,
                    user: "",
                    authToken: "",
                    backurl: "",
                    expireDate: "",
                });


                localStorage.setItem(
                    "LoginMobileAuth",
                    JSON.stringify({
                        loggedIn: false,
                        user: "",
                        authToken: "",
                        backurl: "",
                        expireDate: "",
                    })
                );


                return {
                    succeed: false,
                    msg: response.data.errorMessage,
                };
            }

        } catch {

            return {
                succeed: false,
                msg: "امکان ارتباط وجود ندارد",
            };

        }

    };


    // ==================================================
    // Logout
    // ==================================================

    const logout = async () => {

        localStorage.setItem(
            "HomeMenuState",
            ""
        );


        props.userLogin({
            loggedIn: false,
            user: "",
            authToken: "",
            backurl: "",
            expireDate: "",
        });


        localStorage.setItem(
            "auth",
            JSON.stringify({
                loggedIn: false,
                user: "",
                authToken: "",
                backurl: "",
                expireDate: "",
            })
        );


        let site = "";


        try {

            site =
                JSON.parse(
                    localStorage.getItem(
                        getFirstDirectory()
                    )
                ).site_EnName;

        } catch {
        }


        window.location.replace(
            "/" + site
        );

    };


    // ==================================================
    // Loading Screen
    // ==================================================

    const loadingView = (
        <div
            style={{
                width: "100%",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                direction: "rtl",
                background: "#ffffff",
            }}
        >
            <div
                style={{
                    textAlign: "center",
                    fontSize: "14px",
                    color: "#666",
                }}
            >
                لطفا صبر نمایید...
                <LinearProgress></LinearProgress>
            </div>
        </div>
    );


    // ==================================================
    // Render
    // ==================================================

    return (
        <Router>

            <CacheProvider value={cacheRtl}>

                <ThemeProvider theme={theme}>

                    <CssBaseline />

                    <div dir="rtl">

                        <button
                            style={{
                                position: "absolute",
                                display: "none",
                            }}
                            id="installApp"
                        >
                            نصب
                        </button>


                        <Suspense fallback={loadingView}>

                            {
                                !LoginState.state &&
                                LoginState.type === "Generall" &&
                                (
                                    <LandingPage
                                        Getsiteinfo={Getsiteinfo}
                                        logout={logout}
                                        NewUserRegistration={
                                            NewUserRegistration
                                        }
                                        LoginNoAuth={
                                            LoginNoAuth
                                        }
                                        LoginMobileAuth={
                                            LoginMobileAuth
                                        }
                                        GetValidationCode={
                                            GetValidationCode
                                        }
                                        GetValidationCodeForget={
                                            GetValidationCodeForget
                                        }
                                        ForgerPassword={
                                            ForgerPassword
                                        }
                                        login={login}
                                    />
                                )
                            }


                            {
                                LoginState.state &&
                                LoginState.type === "Generall" &&
                                (
                                    <Layout
                                        logout={logout}
                                    />
                                )
                            }


                            {
                                LoginState.state &&
                                LoginState.type === "Ldf" &&
                                (
                                    <LayoutLdf
                                        logout={logout}
                                    />
                                )
                            }

                        </Suspense>

                    </div>

                </ThemeProvider>

            </CacheProvider>

        </Router>
    );
}


// ======================================================
// Redux
// ======================================================

const mapStateToProps = (state) => {

    return {
        loggedIn: state.auth.loggedIn,
        auth: state.auth,
    };

};


const mapDispatchToProps = (dispatch) => {

    return {

        userLogin: (params) =>
            dispatch(
                authActions.login(params)
            ),

        SetSiteInfo: (params) =>
            dispatch(
                locationActions.SetSiteInfo(params)
            ),

    };

};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);